module.exports = __webpack_public_path__ + "media/images/flags/16/Qatar-e89f449d84a564cad528aa3e50d602f9.png";